import { render, staticRenderFns } from "./pagamento-outros-servicos.vue?vue&type=template&id=1261e2e4&scoped=true&"
import script from "./pagamento-outros-servicos.vue?vue&type=script&lang=js&"
export * from "./pagamento-outros-servicos.vue?vue&type=script&lang=js&"
import style0 from "./pagamento-outros-servicos.vue?vue&type=style&index=0&id=1261e2e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1261e2e4",
  null
  
)

export default component.exports